<template>
  <section id="footer" class="footer-area rg-footer">
    <div class="container">
      <!-- FOOTER MAIN -->
      <div class="footer-main">
        <div class="row">
          <!-- Redes Sociales -->
          <div class="col-lg-12">
            <div class="footer-widget">
              <!-- logo and social media -->

              <div class="footer-logo row">
                <div class="col-md-2">
                  <img src="https://cdn.redgirasol.com/green/LOGOS/redgirasol.png" width="200px"
                    class="mr-auto" style="float:left" alt="logo">
                </div>
                <div class="col-md-3">
                  <div class="shared-media-rg">
                    <ul class="copy__links footer-media-icons list-inline social-media">
                      <li class="mr-2"><a
                          @click="redirectThirdSite('https://www.facebook.com/redgirasol/', ThirdSiteText, true)"
                          target="_blank" rel="noopener noreferrer"><em class="fab fa-facebook-f"></em></a></li>
                      <li class="mr-2"><a
                          @click="redirectThirdSite('https://twitter.com/redgirasol', ThirdSiteText, true)"
                          target="_blank" rel="noopener noreferrer"><em class="fab fa-twitter"></em></a></li>
                      <li class="mr-2"><a
                          @click="redirectThirdSite('https://www.instagram.com/redgirasol/', ThirdSiteText, true)"
                          target="_blank" rel="noopener noreferrer"><em class="fab fa-instagram"></em></a></li>
                      <li class="mr-2"><a
                          @click="redirectThirdSite('https://www.linkedin.com/company/10346607/', ThirdSiteText, true)"
                          target="_blank" rel="noopener noreferrer"><em class="fab fa-linkedin-in"></em></a></li>
                      <li class="mr-2"><a
                          @click="redirectThirdSite('https://www.youtube.com/@redgirasol7972/videos', ThirdSiteText, true)"
                          target="_blank" rel="noopener noreferrer"><em class="fab fa-youtube"></em></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Categorias -->
          <div class="col-lg-12">
            <div class="row">
              <!-- información -->
              <div class="col-sm-4">
                <div class="footer-widget">
                  <h6 class="widget-title primary">Información</h6>
                  <div class="footer-menu-link">
                    <ul class="list-unstyled">
                      <li><a  @click.stop="openNewTabWithUrl(`${supportBase}48000456605`)">Centro de ayuda inversionistas</a></li>
                      <li><a  @click.stop="openNewTabWithUrl(`${supportBase}48000456606`)">Centro de ayuda solicitantes</a></li>
                      <li><a  @click.stop="openNewTabWithUrl(`${supportBase}48000456607`)">Centro de ayuda instaladores</a></li>
                      <li><a @click.stop="openNewTabWithUrl(financialEducation)">Educación Financiera</a></li> 
                      <li><router-link :to="{name: 'reporteRoboExtravio'}">Reporte por robo o extravío</router-link></li>
                      <li><router-link :to="{name: 'aclaraciones'}">Aclaraciones y reclamaciones (UNE)</router-link></li>
                      <li><a @click.stop="openNewTabWithUrl('https://cdn.redgirasol.com/informativos/Aviso-Datos-UNE.pdf')">Aviso de datos de la UNE</a></li>
                      <li><a @click.stop="openNewTabWithUrl('https://cdn.redgirasol.com/informativos/Aviso-Datos-REDECO.pdf')">Aviso de datos de REDECO</a></li>
                      <li><router-link :to="{name: 'seguridad'}">Seguridad y antifraude</router-link></li>
                      <li><a @click.stop="openNewTabWithUrl(blog)">Blog</a></li> 
                      <li><a @click.stop="openNewTabWithUrl(statusUrl)">Estado: <span :class="websiteStatus == 'ONLINE' ? 'primary' : 'color-gray-4' ">{{ websiteStatus }}</span></a></li> 
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="footer-widget">
                  <h6 class="widget-title primary">Transparencia</h6>
                  <div class="footer-menu-link">
                    <ul class="list-unstyled">
                      <li><a @click.stop="redirectThirdSite(dof)">Autorización Fintech</a></li>
                      <li><router-link :to="{name: 'reporteCuitf17'}">Estadísticas trimestrales</router-link></li>
                      <li><router-link :to="{name: 'estadosFinancieros'}">Estados financieros</router-link></li>
                      <li><router-link :to="{name: 'calificacion'}">Metodología de evaluación y calificación</router-link></li>
                    </ul>
                  </div>
                </div>
                <div class="footer-widget">
                  <h6 class="widget-title primary">Promociones</h6>
                  <div class="footer-menu-link">
                    <ul class="list-unstyled">
                      <li><a @click.stop="openNewTabWithUrl('https://soporte.redgirasol.com/support/solutions/folders/48000693412')">Inversionistas</a></li>
                      <li><a @click.stop="openNewTabWithUrl('https://soporte.redgirasol.com/support/solutions/folders/48000693679')">Solicitantes</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <!-- Alianzas -->
                <div class="footer-widget">
                  <h6 class="widget-title primary">Alianzas</h6>
                  <div class="footer-menu-link">
                    <ul class="list-unstyled">
                      <li><router-link :to="{name: 'suppliersPage'}">Instaladores solares</router-link></li>
                      <li><router-link :to="{name: 'emerge'}">Coca-Cola FEMSA y GIZ</router-link></li>
                      <li><router-link :to="{name: 'promotersPage'}">Promotores de Inversión</router-link></li>
                    </ul>
                  </div>
                </div>
                <div class="footer-widget">
                  <h6 class="widget-title primary">Legal</h6>
                  <div class="footer-menu-link">
                    <ul class="list-unstyled">
                      <li><router-link :to="{name: 'avisoPrivacidad'}">Aviso de Privacidad</router-link></li>
                      <li><router-link :to="{name: 'terminosCondiciones'}">Términos y Condiciones</router-link></li>
                    </ul>
                  </div>

                  <div class="mt--20">
                    <ul class="copy__links mb footer-media-icons">
                      <!-- <li class="mb--15">
                        <a @click="redirectThirdSite('http://www.afico.org/plataformas.html', ThirdSiteText, true)"
                          class="rounded" target="_blank" rel="noopener noreferrer">
                          <image-from-source path="/img/aficob.png" style="width:80px !important;" />
                        </a>
                      </li>
                      <li class="mb--15">
                        <a @click="redirectThirdSite('https://anes.org.mx/index.php/socios/', ThirdSiteText, true)"
                          class="rounded" target="_blank" rel="noopener noreferrer">
                          <image-from-source path="/img/ANES-01.png" style="width:30px !important;" />
                        </a>
                      </li>
                      <li class="mb--15">
                        <a @click="redirectThirdSite('https://www.amif.mx/', ThirdSiteText, true)" class="rounded"
                          target="_blank" rel="noopener noreferrer">
                          <image-from-source path="/img/LOGO_AMIF.png" style="width:80px !important;" />
                        </a>
                      </li>
                      <li class="mb--15">
                        <a @click="redirectThirdSite('https://www.circulodecredito.com.mx/', ThirdSiteText, true)"
                          class="rounded" target="_blank" rel="noopener noreferrer">
                          <image-from-source path="/img/CIRCULOCREDITO-01.png" style="width:50px !important;" />
                        </a>
                      </li> -->
                      <li class="mb--15">
                        <router-link :to="{ name: 'buroEntidadesFinancieras' }">
                          <img src="https://cdn.redgirasol.com/green/LOGOS/buro_entidades_financieras.png"
                            style="width:50px !important;">
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-sm-12">
                <p class="p-footer mb--50">
                Red Girasol, S.A.P.I. de C.V., Institución de Financiamiento Colectivo en términos de la Ley para
                Regular las Instituciones de Tecnología Financiera, es una sociedad autorizada, regulada y
                supervisada por las autoridades financieras.
                Número de autorización: <router-link class="router-link-customize" to=""
                  @click.native="redirectThirdSite('http://www.dof.gob.mx/nota_detalle.php?codigo=5651691&fecha=11/05/2022', ThirdSiteText)">
                  P137/2021</router-link>
                <br><br>
                Ni el Gobierno Federal ni las entidades de la administración pública paraestatal podrán
                responsabilizarse o garantizar los recursos de los clientes que sean utilizados en las operaciones
                que celebren con las ITF o frente a otros,
                así como tampoco asumir alguna responsabilidad por las obligaciones contraídas por las ITF o por
                algún cliente frente a otro, en virtud de las operaciones que celebren.
                <!-- <br><br> -->
                <!-- <span v-html='footerText'></span> -->
              </p>
              </div>
            </div>

            <div class="row mb--50 footer-logos">
              <div v-for="(item, index) in entities" class="col-sm-2 col-md-3 col-lg-1 text-align-center mb--10">
                <img :src="`${imgBase}${item.img}`" :alt="item.title">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- FOOTER BOTTOM -->
      <div class="footer-bottom">
        <div class="row">
          <div class="col-md-6">
            <div class="footer-copyright">
              <span class="copyright-text">© Red Girasol S.A.P.I. de C.V., Institución de Financiamiento Colectivo <br>
                {{ year }} | Todos los derechos reservados.</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="footer-bottom-link">
              <ul class="list-unstyled">
                <li><router-link class="bold white" :to="{ name: 'comisiones' }">Consulta los Costos y las Comisiones <br> de nuestros
                    productos</router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

const entities = [
  { title: "SHCP", img: "logo-footer-shcp.png", url: ""},
  { title: "CNBV", img: "logo-footer-cnbv.png", url: ""},
  { title: "BANXICO", img: "logo-footer-banxico.png", url: ""},
  { title: "CONDUSEF", img: "logo-footer-condusef.png", url: ""},
  { title: "CERTIFIED B", img: "logo-footer-b.png", url: ""},
  { title: "FOR THE PLANET", img: "logo-footer-fortheplanet.png", url: ""},
  // { title: "CARBON MARK", img: "logo-footer-carbon.png", url: ""},
  { title: "AFICO", img: "logo-footer-afico.png", url: ""},
  { title: "AMIF", img: "logo-footer-amif.png", url: ""},
  { title: "ANES", img: "logo-footer-anes.png", url: ""},
  { title: "CÍRCULO DE CRÉDITO", img: "logo-footer-cdc.png", url: ""},
];

export default {
  name: "RGFooter",
  props: {
    year: {
      type: Number
    }
  },
  data() {
    return {
      footerText: '',
      financialEducation: "https://blog.redgirasol.com/category/educacion-financiera/", 
      supportBase: 'https://soporte.redgirasol.com/support/solutions/',
      blog: "https://blog.redgirasol.com/",
      dof: "https://dof.gob.mx/nota_detalle.php?codigo=5651691&fecha=11/05/2022#gsc.tab=0",
      entities:entities,
      imgBase: "https://cdn.redgirasol.com/nuevo_portal/logos/footer/",
      websiteStatus: null,
      statusUrl: "https://status.redgirasol.com/"
    }
  },
  async mounted() {
    await this.getOnlineStatus();
  },
  methods: {
    async getOnlineStatus() {
      try {
        await fetch(`https://api.onlineornot.com/v1/checks/${this.StatusId}`, {
          headers: {
            'Authorization': `Bearer ${this.StatusToken}`,
          },
        })
          .then(response => response.json())
          .then(data => {
            this.websiteStatus = data.result.status;
          });

      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style>
#footer .container {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

#footer .copyright-text {
  font-size: 12px !important;
  color: var(--color-white) !important;
}

#footer .footer-menu-link li a {
  color: var(--color-light);
  padding: 8px 0;
  font-size: 12px;
  line-height: 1;
}

#footer .footer-menu-link li a:hover {
  color: var(--color-primary);
}

.p-footer {
  font-size: 12px;
  line-height: 20px;
  color: var(--color-light);
  text-align: justify;
}

.list-unstyled>li {
  font-size: 12px !important;
}

.rg-footer {
  background-color: #3B3A3E !important;
}

.social-media {
  display: flex;
  grid-gap: 28px;
  line-height: 3rem;
}

.footer-logo {
  width: 100%;
  float: left;
  margin-right: auto;
  margin-bottom: 30px;
}

.footer-area.rg-footer {
  padding-top: 60px;
}

.rg-footer .footer-list {
  padding-bottom: 30px;
}

.footer-text {
  font-size: 12px;
  line-height: 20px;
}

.footer-area .copyright-shared .copy__links.mb {
  margin-bottom: 20px;
}

.footer-area .copyright-shared .copy__links.footer-media-icons li a {
  font-size: 15px;
}

.rg-footer.footer-area .copyright-shared .copy__desc {
  color: #fff;
}

.rg-footer.footer-area .copyright-shared:after {
  background-color: #fff;
  opacity: 1;
}

.rg-footer.footer-area .shared-media-rg:after {
  background-color: #fff;
  opacity: 0.5;
  margin-top: -2.5rem;
}

.shared-media-rg em {
  color: #fff;
}

.copy__desc {
  font-size: 12px !important;
}

.footer__title {
  margin-bottom: 15px !important;
}

/* .vs-divider {
    border-bottom: solid 3px #9d9c9e;
    margin-left: 1px;
    margin-right: 1px;
  } */

.router-link-customize {
  color: #b5b5c3 !important;
  font-weight: 600 !important;
}

.router-link-customize:hover {
  color: #28de18 !important;
  text-decoration: underline !important;
}

.img-icon {
  float: left;
  width: 18px;
}

.footer-widget {
  margin-bottom: 40px !important;
}

.footer-logos {
  justify-content: center;
  align-items: center;
}

</style>